

const LessonsServices = {
	getCurrentLesson: () => Promise.resolve({})
}

export default LessonsServices
